<template>
  <figure class="flex-all-center loading">
    <img src="../../assets/images/loading.gif" alt="loading" />
  </figure>
</template>

<script>
export default {
  name: "Loading",
};
</script>

<style scoped>
.loading {
  min-height: calc(100vh - 175px);
}
</style>



// WEBPACK FOOTER //
// src/components/sp/Loading.vue